import React from 'react';
import { SkeletonLoader } from '@sm/webassets';

export const SignInListCardSkeletonLoader: React.FC = () => {
  return (
    <SkeletonLoader
      data-testid="sign-in-list-loader"
      className="wds-display--block"
      title="Loader"
      width="320px"
      height="600px"
    >
      <rect width="100%" height="100%" />
    </SkeletonLoader>
  );
};

export default SignInListCardSkeletonLoader;
